import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideocam = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.4784 16.0548L16.0517 13.9425V10.0575L19.4784 7.94521C19.787 7.75496 20.1744 7.74659 20.491 7.92333C20.8076 8.10008 21.0037 8.43427 21.0037 8.79683V15.2032C21.0037 15.5657 20.8076 15.8999 20.491 16.0767C20.1744 16.2534 19.787 16.245 19.4784 16.0548Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.99625 8.9975C2.99625 7.34064 4.33939 5.9975 5.99625 5.9975H13.0517C14.7085 5.9975 16.0517 7.34064 16.0517 8.9975V15.0025C16.0517 16.6594 14.7085 18.0025 13.0517 18.0025H5.99624C4.33939 18.0025 2.99625 16.6594 2.99625 15.0025V8.9975Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgVideocam);
export default ForwardRef;
